import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    event.stopPropagation()
    this.element.closest("form").requestSubmit()
  }
}
